import React from 'react'
import CategoriesBanner from '../components/CategoriesBanner'
import Navbar from '../components/Navbar'
import BusinessHero from '../components/Business/BusinessHero'
import BusinessAbourt from '../components/Business/BusinessAbourt'
import BusinessReviews from '../components/Business/BusinessReviews'
//import Footer from '../components/Footer';

function BusinessPage() {
    return (
        <div>
            <CategoriesBanner />
            <Navbar />
            <BusinessHero />
            <BusinessAbourt />
            <BusinessReviews />
            {/* <Footer /> */}
        </div>
    )
}

export default BusinessPage